/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnsureEmailValidityRequest } from '../../models/ensure-email-validity-request';

export interface PostEnsureEmailValidity$Params {
  body?: EnsureEmailValidityRequest;
}

export function postEnsureEmailValidity(
  http: HttpClient,
  rootUrl: string,
  params?: PostEnsureEmailValidity$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, postEnsureEmailValidity.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    }),
  );
}

postEnsureEmailValidity.PATH = '/Registration/ensure-email-validity';
